module.exports = __webpack_public_path__ + "img/abundant2.d563ffa5.png";